import React from "react"
import tw from "twin.macro"
import Link from "next/link"
import { useTranslation } from "next-i18next"

export const ContactUs = () => {
  const { t } = useTranslation("footer")
  return (
    <div tw="text-center space-y-6" css={[tw`mobile-lg:(w-[260px])`]}>
      <h4 tw="title-4">{t("contact_us_modal.heading")}</h4>
      <p tw="text-lg text-base-4 space-y-4">
        <span tw="block">
          <span tw="block">{t("contact_us_modal.email_us")}</span>
          <Link tw="block" href="mailto:hello@joinbonsai.co">
            hello@joinbonsai.co
          </Link>
        </span>
        <span tw="block">
          <span tw="block">{t("contact_us_modal.text_us")}</span>
          <Link tw="block" href="tel:+1917-205-9240">
            +1 (917) 205-9240
          </Link>
        </span>
      </p>
    </div>
  )
}
